import _ from 'lodash';

// Sổ nháp điều hướng non-reactive, thay cho goto.rma.tab và goto.rma.maintenance.
// KHÔNG phải Zustand store: nhánh này trước đây bị `_.assign` mutate thẳng vào Redux state
// mà không dispatch, nên không có subscriber nào và không có re-render. Bọc thành store sẽ
// thêm re-render vào chỗ trước đây không có. Xem spec §3.
const rmaNavigationState: Record<string, any> = {};

// Reset giữ nguyên identity của object cấp trên cùng để consumer đang giữ reference
// (ví dụ props.searchGoto của devicesTable) không trỏ vào object mồ côi.
/**
 * Restores the RMA navigation state to its defaults so the RMA screens reopen clean. Deletes every existing key on the shared rmaNavigationState object, then assigns an undefined tab plus a maintenance block holding the All models selection and an empty search value.
 *
 * @returns Nothing.
 */
const resetRmaNavigationState = () => {
  _.forEach(_.keys(rmaNavigationState), (key) => {
    delete rmaNavigationState[key];
  });
  _.assign(rmaNavigationState, {
    tab: undefined,
    maintenance: {
      select: { model: 'All models' },
      search: { searchValue: undefined },
    },
  });
};

resetRmaNavigationState();

export { rmaNavigationState, resetRmaNavigationState };
